import React from 'react';
import PropTypes from 'prop-types';
import PreformattedText from 'Components/ComponentLibrary/Atoms/Text/PreformattedText';
import { disclosureInfoUri } from 'Consts/clientUris';

// This is a hack.  A pattern hasn't been established for this.
const DisclaimerWithLink = ({ text }) => {
  const [partA, partB] = text.split('Click here');

  return (
    <PreformattedText
      align="left"
      color="mediumGray"
      value={
        <>
          {partA}
          {'Click '}
          <a href={disclosureInfoUri} rel="noopener noreferrer" target="_blank">
            here
          </a>
          {partB}
        </>
      }
      weight="book"
    />
  );
};

DisclaimerWithLink.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default DisclaimerWithLink;
